import script from "./RightIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./RightIndex.vue?vue&type=script&setup=true&lang=js"

import "./RightIndex.vue?vue&type=style&index=0&id=5bb9fb61&lang=css"
import "./RightIndex.vue?vue&type=style&index=1&id=5bb9fb61&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb9fb61"]])

export default __exports__